import { color } from "../../../../../../mui-theme/palette";

export const styles = {
  contentContainer: {
    padding: 12,
    backgroundColor: color.white,
    marginBottom: 12,
  },
  iconContainer: {
    borderRadius: 12,
    borderWidth: 0,
    backgroundColor: color.redLightest,
  },
  /* PHKL Custom -s*/
  trainingIcon: {
    width: 56,
    height: 56,
    backgroundColor: "rgb(255, 228, 230)",
    borderWidth: 0,
    opacity: 1,
    borderRadius: 12,
  },
  /* PHKL Custom -e*/
};
